import React from "react";
import { Route } from "react-router-dom";
import PlaceV2 from "../pages/PlaceV2";
import OffersPage from "../pages/OffersPage";
import BottomNavLayout from "../layouts/BottomNavLayout";

export const mainRoutes = (
  <>
    <Route
      path="/"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
    <Route
      path="/place/:pub_id"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
    <Route path="/place/:pub_id/offers" element={<OffersPage />} />
    <Route
      path="*"
      element={
        <BottomNavLayout>
          <PlaceV2 />
        </BottomNavLayout>
      }
    />
  </>
);
